let audioCtx = null;
let buffer = [];
let debounceTimer = null;

const DEBOUNCE_MS = 5000;

function getAudioContext() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioCtx;
}

function playBip(freq, durationMs, startTime, volume = 0.15) {
  const ctx = getAudioContext();
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();

  osc.type = 'sine';
  osc.frequency.value = freq;
  gain.gain.value = volume;

  osc.connect(gain);
  gain.connect(ctx.destination);

  // Fade out suave no final
  gain.gain.setValueAtTime(volume, startTime + durationMs / 1000 - 0.03);
  gain.gain.linearRampToValueAtTime(0, startTime + durationMs / 1000);

  osc.start(startTime);
  osc.stop(startTime + durationMs / 1000);
}

function playSound(maxSeverity, count) {
  const ctx = getAudioContext();
  const now = ctx.currentTime;

  switch (maxSeverity) {
    case 3: // Media — 1 bip curto suave
      playBip(440, 150, now, 0.1);
      break;

    case 4: // Alta — 2 bips medios
      playBip(600, 200, now, 0.15);
      playBip(600, 200, now + 0.3, 0.15);
      break;

    case 5: // Desastre — 3 bips urgentes crescendo
      playBip(800, 200, now, 0.12);
      playBip(800, 200, now + 0.3, 0.18);
      playBip(800, 200, now + 0.6, 0.25);
      break;

    case 6: // API Down — 1 bip grave longo
      playBip(300, 400, now, 0.15);
      break;

    default:
      playBip(440, 150, now, 0.08);
      break;
  }

  // Bip extra de volume se 5+ alarmes acumulados
  if (count >= 5) {
    const lastBipEnd = maxSeverity === 5 ? 0.9 : maxSeverity === 4 ? 0.6 : 0.3;
    playBip(350, 150, now + lastBipEnd, 0.1);
  }
}

function flush() {
  if (buffer.length === 0) return;

  const soundEnabled = localStorage.getItem('soundEnabled');
  if (soundEnabled !== null && JSON.parse(soundEnabled) === false) {
    buffer = [];
    return;
  }

  const maxSev = Math.max(...buffer);
  const count = buffer.length;
  buffer = [];

  playSound(maxSev, count);
}

export function queueAlarmSound(severity, count = 1) {
  for (let i = 0; i < count; i++) {
    buffer.push(severity);
  }

  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }
  debounceTimer = setTimeout(flush, DEBOUNCE_MS);
}
